import type { ControlResultWorkflowCurrentStep } from "@/spz-api/model";
import { WorkflowBadge } from "@spz/ui/components/workflow-badge";

type WorkflowStepTagProps = {
  workflowStep: ControlResultWorkflowCurrentStep;
  className?: string;
};

/**
 * WorkflowStepTag - Displays a workflow step badge
 *
 * This is a thin wrapper around WorkflowBadge for backward compatibility
 * and to provide a domain-specific API in the workflows feature.
 */
export const WorkflowStepTag = ({
  workflowStep,
  className,
}: WorkflowStepTagProps) => {
  return (
    <WorkflowBadge
      labelKey={workflowStep.key_name}
      variant={workflowStep.variant}
      className={className}
    />
  );
};
